import React from 'react';
import equipo1 from "../assets/equipo1.webp"
import equipo2 from "../assets/equipo2.webp"
import equipo4 from "../assets/equipo4.webp"
import equipo5 from "../assets/equipo5.webp"
import equipo6 from "../assets/equipo6.webp"
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from './ScrollToTop';

const Equipo = () => {
  const integrantes = [
    {
      img: equipo1,
      nombre: "Javier Duque",
      cargo: "Director General",
      bio: "Ingeniero Industrial con especializacion en Negociación y Manejo de Conflictos, con experiencia en la docencia por más de 12 años. Conferencista en eventos de caracter educativo. Es columnista de diferentes diarios de la Costa Caribe Colombiana."
    },
    {
      img: equipo2,
      nombre: "Juan Duque",
      cargo: "Director Institucional",
      bio: "Promotor de la ejecución de proyectos y actividades que la Fundadocente JDD define en pro de los educadores. Con experiencia por mas de 25 años en administración de instituciones educativas de la Comunidad de los Hermanos Cristianos de La Salle."
    },
    {
      img: equipo4,
      nombre: "Jose Pertuz",
      cargo: "Revisor Fiscal",
      bio: "Contador público especializado en derecho tributario, con experiencia en revisorías fiscales de entidades sin ánimo de lucro por más de 24 años, vela por la salvaguarda de los activos de la Fundadocente JDD, y hacer cumplir las normas de carácter legal establecidas por la legislación Colombiana."
    },
    {
      img: equipo5,
      nombre: "Daniela Maria Duque Caro",
      cargo: "Asesora Jurídica",
      bio: "Abogada con experiencia en Derecho empresarial y entidades sin animo de lucro, con énfasis en derecho financiero. Actualmente cursa Maestría en Derecho Empresarial Internacional en la Universidad de Tilburg Holanda."
    },
    {
      img: equipo6,
      nombre: "Jaime Carmona Torres",
      cargo: "Asesor Contable",
      bio: "Contador público Titulado, con experiencia en la coordinación de las áreas financieras - contables de empresas privadas y entidades sin ánimo de lucro por más de 5 años."
    }
  ];

  return (
    <>
      <ScrollToTop />
      <Navbar />
      
      <div className='bg-gray-50 min-h-screen py-12 md:py-20 px-4'>
        <div className='max-w-7xl mx-auto'>
          
          {/* Encabezado Principal */}
          <div className='text-center mb-16 md:mb-24'>
            <h1 className='text-4xl md:text-6xl lg:text-7xl font-black text-slate-900 mb-6 tracking-tight'>
              • Conoce nuestro <span className='text-blue-700'>equipo</span> •
            </h1>
            <div className='w-24 h-2 bg-blue-600 mx-auto rounded-full'></div>
          </div>

          {/* Grid de Tarjetas - Ajustado para ser responsivo */}
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12'>
            {integrantes.map((persona, index) => (
              <div 
                key={index} 
                className='bg-white group rounded-[2.5rem] p-8 md:p-10 shadow-sm border border-gray-100 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 flex flex-col'
              >
                {/* Contenedor de Imagen */}
                <div className='relative w-44 h-44 mx-auto mb-8'>
                  <div className='absolute inset-0 bg-blue-50 rounded-full scale-110 group-hover:bg-blue-600 transition-colors duration-500'></div>
                  <img 
                    className='relative w-full h-full object-cover rounded-full border-4 border-white shadow-xl' 
                    src={persona.img} 
                    alt={persona.nombre} 
                  />
                </div>

                {/* Información del Integrante */}
                <div className='text-center flex flex-col flex-grow'>
                  <h3 className='text-2xl md:text-3xl font-bold text-slate-800 mb-2 leading-tight'>
                    {persona.nombre}
                  </h3>
                  
                  {/* Badge de Cargo */}
                  <div className='mb-6'>
                    <span className='inline-block px-4 py-1.5 bg-blue-50 text-blue-700 text-xs font-bold uppercase tracking-widest rounded-lg'>
                      {persona.cargo}
                    </span>
                  </div>

                  {/* Biografía con texto original */}
                  <div className='pt-6 border-t border-gray-50 mt-auto'>
                    <p className='text-slate-600 text-base leading-relaxed font-light text-justify md:text-center'>
                      {persona.bio}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Equipo;